import Vue from 'vue'

class ReportRepository {

  usages(data) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: '/api/report/usages',
        method: 'post',
        data,
      })
      .then(response => {
        resolve(response.data)
      }).catch(err => {
        reject(err)
      })
    })
  }

  usagesExport(data) {
    return new Promise((resolve, reject) => {
      Vue.auth.download({
        url: '/api/report/usages/export',
        method: 'post',
        data,
      })
      .then(response => {
        resolve(response.data)
      }).catch(err => {
        reject(err)
      })
    })
  }


  offline(data) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: '/api/report/offline',
        method: 'post',
        data,
      })
      .then(response => {
        resolve(response.data)
      }).catch(err => {
        reject(err)
      })
    })
  }

  offlineExport(data) {
    return new Promise((resolve, reject) => {
      Vue.auth.download({
        url: '/api/report/offline/export',
        method: 'post',
        data,
      })
          .then(response => {
            resolve(response.data)
          }).catch(err => {
        reject(err)
      })
    })
  }


  cpExport(data) {
    return new Promise((resolve, reject) => {
      Vue.auth.download({
        url: '/api/report/export-cp',
        method: 'get',
        data,
      })
      .then(response => {
        resolve(response.data)
      }).catch(err => {
        reject(err)
      })
    })
  }

  evsesExport(data) {
    return new Promise((resolve, reject) => {
      Vue.auth.download({
        url: '/api/report/export-evses',
        method: 'get',
        data,
      })
          .then(response => {
            resolve(response.data)
          }).catch(err => {
        reject(err)
      })
    })
  }

  customersExport() {
    return new Promise((resolve, reject) => {
      Vue.auth.download({
        url: '/api/report/export-customers',
        method: 'get',
      })
          .then(response => {
            resolve(response.data)
          }).catch(err => {
        reject(err)
      })
    })
  }

  licencesExport() {
    return new Promise((resolve, reject) => {
      Vue.auth.download({
        url: '/api/report/export-licences',
        method: 'get',
      })
          .then(response => {
            resolve(response.data)
          }).catch(err => {
        reject(err)
      })
    })
  }

  organizationsExport() {
    return new Promise((resolve, reject) => {
      Vue.auth.download({
        url: '/api/report/export-organizations',
        method: 'get',
      })
          .then(response => {
            resolve(response.data)
          }).catch(err => {
        reject(err)
      })
    })
  }

  usersExport() {
    return new Promise((resolve, reject) => {
      Vue.auth.download({
        url: '/api/report/export-users',
        method: 'get',
      })
          .then(response => {
            resolve(response.data)
          }).catch(err => {
        reject(err)
      })
    })
  }

  authorizationWithoutCdrExport(data = {}) {
    return new Promise((resolve, reject) => {
      Vue.auth.download({
          url: '/api/report/export-authorization-without-cdr',
          method: 'get',
          data,
      })
      .then(response => {
          resolve(response.data)
      }).catch(err => {
          reject(err)
      })
    })
  }

  evseStatuesExport() {
    return new Promise((resolve, reject) => {
      Vue.auth.download({
          url: '/api/report/export-evse-statues',
          method: 'get',
      })
      .then(response => {
          resolve(response.data)
      }).catch(err => {
          reject(err)
      })
    })
  }

    tele2EventsExport(data) {
    return new Promise((resolve, reject) => {
      Vue.auth.download({
          url: '/api/report/export-tele2-events',
          method: 'get',
          data,
      })
      .then(response => {
          resolve(response.data)
      }).catch(err => {
          reject(err)
      })
    })
  }

  activeOfflineChargingPointsExport(data) {
    return new Promise((resolve, reject) => {
      Vue.auth.download({
          url: '/api/report/export-active-offline-charging-points',
          method: 'get',
          data,
      })
      .then(response => {
          resolve(response.data)
      }).catch(err => {
          reject(err)
      })
    })
  }

  simOperatorsExport(data) {
    return new Promise((resolve, reject) => {
      Vue.auth.download({
          url: '/api/report/export-sim-operators',
          method: 'get',
          data,
      })
      .then(response => {
          resolve(response.data)
      }).catch(err => {
          reject(err)
      })
    })
  }

  customersWithPermissionsConfigExport() {
    return new Promise((resolve, reject) => {
      Vue.auth.download({
          url: '/api/report/export-customers-with-permissions-config',
          method: 'get',
      })
      .then(response => {
          resolve(response.data)
      }).catch(err => {
          reject(err)
      })
    })
  }
}

export default new ReportRepository()